import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 16, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.55, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, lead, align = "left" }) => (
  <Reveal className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-gold flex items-center gap-3 justify-inherit">
      <span className="inline-block h-px w-8 bg-gold" aria-hidden="true" />
      {eyebrow}
    </p>
    <h2 className="font-display text-3xl sm:text-4xl font-bold uppercase tracking-tight text-slate-100 mt-3">
      {title}
    </h2>
    {lead ? <p className="text-slate-400 mt-4 leading-relaxed">{lead}</p> : null}
  </Reveal>
);
